import { Spacer } from "@/components/Spacer";
import Section0201Desktop from "@/assets/images/section-02-01-desktop.png";
import Section0202Desktop from "@/assets/images/section-02-02-desktop.png";
import Section0201Mobile from "@/assets/images/section-02-01-mobile.png";
import Section0202Mobile from "@/assets/images/section-02-02-mobile.png";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function Section02({ isMobile }: { isMobile: boolean }) {
  const sectionRef = useRef(null);
  const section02Ref = useRef(null);
  const isInView = useInView(sectionRef, {
    once: true,
    margin: "0px 0px -50% 0px",
  });
  const isSection02InView = useInView(section02Ref, {
    once: true,
    margin: "0px 0px -50% 0px",
  });

  return (
    <div className="flex flex-col items-center desktop:py-[100px] desktop:px-[32px] py-[80px] px-[24px] bg-[#ffffff]">
      <motion.div
        id="section-02-01"
        className="flex flex-col items-center"
        ref={sectionRef}
        initial={{
          opacity: 0,
          scale: 1,
          rotate: 0,
          skewX: 0,
          skewY: 0,
          y: 20,
          x: 0,
        }}
        animate={
          isInView
            ? {
                opacity: 1,
                y: 0,
                transition: {
                  type: "spring",
                  stiffness: 300,
                  damping: 80,
                  mass: 1,
                  delay: 0.35,
                },
              }
            : {
                opacity: 0,
                y: 20,
                transition: {
                  type: "spring",
                  stiffness: 300,
                  damping: 80,
                  mass: 1,
                  delay: 0.35,
                },
              }
        }
      >
        <div
          className="font-pre-semibold desktop:text-[20px] text-[14px] leading-[1.2em] text-[#868686] text-center"
          style={{ letterSpacing: -0.76 }}
        >
          병원 갈 시간은 없고, 검색하자니 막막하셨다면?
        </div>
        <Spacer height={isMobile ? 8 : 12} />
        <div
          className="font-pre-bold desktop:text-[38px] text-[24px] leading-[140%] text-[#151515] text-center"
          style={{ letterSpacing: -0.76 }}
        >
          언제 어디서나 헬시어와 함께 하세요
        </div>
      </motion.div>
      <Spacer height={isMobile ? 40 : 60} />
      <motion.div
        id="section-02-02"
        className="flex desktop:flex-row flex-col gap-[24px]"
        ref={section02Ref}
        initial={{
          opacity: 0,
          scale: 1,
          rotate: 0,
          skewX: 0,
          skewY: 0,
          y: 30,
          x: 0,
        }}
        animate={
          isSection02InView
            ? {
                opacity: 1,
                y: 0,
                transition: {
                  type: "spring",
                  stiffness: 300,
                  damping: 100,
                  mass: 1,
                  delay: 0.2,
                },
              }
            : {
                opacity: 0,
                y: 30,
                transition: {
                  type: "spring",
                  stiffness: 300,
                  damping: 100,
                  mass: 1,
                  delay: 0.2,
                },
              }
        }
      >
        <Card
          title="내 질환이 궁금하다면?"
          subTitle="헬시어로 먼저 확인해보세요."
          description="헬시어 닥터AI가 무료로 증상을 감별해요."
          subDescription="클릭 몇번으로 예상 질환과 중증도를 알 수 있어요."
          image={isMobile ? Section0201Mobile : Section0201Desktop}
          isMobile={isMobile}
        />

        <Card
          title="증상에 맞는 질환과 약,"
          subTitle="병원정보까지 한번에 확인할 수 있어요."
          description="질환에 대한 자세한 정보와 증상에 맞는"
          subDescription="진료과 병원을 더 쉽고 빠르게 확인해보세요."
          image={isMobile ? Section0202Mobile : Section0202Desktop}
          isMobile={isMobile}
        />
      </motion.div>
    </div>
  );
}

const Card = ({
  title,
  subTitle,
  description,
  subDescription,
  image,
  isMobile,
}: {
  title: string;
  subTitle: string;
  description: string;
  subDescription: string;
  image: string;
  isMobile: boolean;
}) => {
  return (
    <div className="desktop:w-[468px] desktop:h-[500px] w-[342px] bg-[#F5F6FA] rounded-[20px] desktop:pt-[50px] pt-[32px]">
      <div className="w-full desktop:pl-[40px] pl-[24px]">
        <div
          className="font-pre-bold desktop:text-[24px] text-[18px] leading-[140%] text-[#131416]"
          style={{ letterSpacing: -0.3 }}
        >
          {title}
        </div>
        <div
          className="font-pre-bold desktop:text-[24px] text-[18px] leading-[140%] text-[#131416]"
          style={{ letterSpacing: -0.3 }}
        >
          {subTitle}
        </div>
        <Spacer height={isMobile ? 8 : 16} />
        <div
          className="font-pre-regular desktop:text-[18px] text-[14px] leading-[150%] text-[#23272E]"
          style={{ letterSpacing: -0.3 }}
        >
          {description}
        </div>
        <div
          className="font-pre-regular desktop:text-[18px] text-[14px] leading-[150%] text-[#23272E]"
          style={{ letterSpacing: -0.3 }}
        >
          {subDescription}
        </div>
      </div>
      <Spacer height={isMobile ? 8 : 23} />
      <img
        src={image}
        alt={title}
        className=" w-full desktop:h-[290px] h-[195px]"
      />
    </div>
  );
};
